// ============================================================================
// GERMAN TRANSLATIONS - JESUS IS NOT
// ============================================================================
// Klarstellungen darüber, wer Jesus ist (und wer er nicht ist)

export const jesusIsNot = [
  {
    category: "liebe",
    text: "Jesus ist nicht rassistisch - Er liebt alle gleichermaßen, unabhängig von ihrer Herkunft",
    reference: "Johannes 4:9 - Die samaritische Frau wundert sich, dass Jesus mit ihr spricht",
    context: "Jesus überwindet die kulturellen und rassischen Barrieren seiner Zeit"
  },
  {
    category: "ausgrenzung",
    text: "Jesus ist nicht ausgrenzend - Er empfängt alle, besonders die Ausgegrenzten",
    reference: "Matthäus 9:10-13 - Jesus isst mit Zöllnern und Sündern",
    context: "Jesus sucht die Verlorenen und Abgelehnten der Gesellschaft"
  },
  {
    category: "urteil",
    text: "Jesus ist nicht verurteilend - Er kam, um zu retten, nicht um zu verdammen",
    reference: "Johannes 3:17 - Gott sandte seinen Sohn nicht, um die Welt zu verdammen",
    context: "Die Mission Jesu ist Rettung und Wiederherstellung"
  },
  {
    category: "gewalt",
    text: "Jesus ist nicht gewalttätig - Er lehrt Feindesliebe",
    reference: "Matthäus 5:44 - Liebt eure Feinde",
    context: "Jesus revolutioniert das Konzept der Gerechtigkeit durch radikale Liebe"
  },
  {
    category: "reichtum",
    text: "Jesus ist nicht materialistisch - Er warnt vor der Liebe zum Geld",
    reference: "Matthäus 6:24 - Ihr könnt nicht Gott dienen und dem Mammon",
    context: "Jesus priorisiert himmlische Schätze über irdische"
  },
  {
    category: "stolz",
    text: "Jesus ist nicht stolz - Er demütigt sich und dient",
    reference: "Johannes 13:5 - Jesus wäscht die Füße seiner Jünger",
    context: "Jesus zeigt, dass Größe im demütigen Dienst liegt"
  },
  {
    category: "legalismus",
    text: "Jesus ist nicht legalistisch - Er stellt Barmherzigkeit über Ritual",
    reference: "Matthäus 12:7 - Barmherzigkeit will ich und nicht Opfer",
    context: "Jesus kritisiert Legalismus, der das Herz des Gesetzes vergisst"
  },
  {
    category: "geschlecht",
    text: "Jesus ist nicht sexistisch - Er ehrt und schätzt Frauen",
    reference: "Johannes 4:27 - Die Jünger wundern sich, dass er mit einer Frau spricht",
    context: "Jesus fordert die patriarchalischen Normen seiner Kultur heraus"
  },
  {
    category: "macht",
    text: "Jesus ist kein Tyrann - Er führt mit Liebe und Beispiel",
    reference: "Matthäus 20:28 - Der Menschensohn kam, um zu dienen",
    context: "Jesus definiert Führung als opfernden Dienst neu"
  },
  {
    category: "rache",
    text: "Jesus ist nicht rachsüchtig - Er vergibt und stellt wieder her",
    reference: "Lukas 23:34 - Vater, vergib ihnen, denn sie wissen nicht, was sie tun",
    context: "Jesus praktiziert radikale Vergebung sogar am Kreuz"
  },
  {
    category: "gleichgültigkeit",
    text: "Jesus ist nicht gleichgültig - Er ist bewegt vom Leiden",
    reference: "Matthäus 9:36 - Er erbarmte sich über die Volksmenge",
    context: "Jesus zeigt tiefe Empathie für die Leidenden"
  },
  {
    category: "elite",
    text: "Jesus ist nicht elitär - Er umgibt sich mit gewöhnlichen Menschen",
    reference: "Markus 1:16-20 - Jesus ruft Fischer als Jünger",
    context: "Jesus wählt gewöhnliche Menschen für seine außergewöhnliche Mission"
  },
  {
    category: "heuchelei",
    text: "Jesus ist kein Heuchler - Er lebt, was er lehrt",
    reference: "Johannes 8:46 - Wer von euch kann mich einer Sünde zeihen?",
    context: "Jesus fordert heraus, einen Widerspruch zwischen seinen Worten und Taten zu finden"
  },
  {
    category: "starrheit",
    text: "Jesus ist nicht starr - Er passt seine Lehre an jede Person an",
    reference: "Johannes 3 - Jesus spricht anders mit Nikodemus als mit der Samariterin",
    context: "Jesus personalisiert seine Botschaft nach den Bedürfnissen jedes Einzelnen"
  },
  {
    category: "tradition",
    text: "Jesus ist kein blinder Traditionalist - Er hinterfragt unterdrückende Traditionen",
    reference: "Markus 7:13 - Ihr hebt Gottes Wort auf durch eure Überlieferung",
    context: "Jesus priorisiert den Geist des Gesetzes über menschliche Traditionen"
  },
  {
    category: "nationalismus",
    text: "Jesus ist nicht nationalistisch - Sein Reich überschreitet Grenzen",
    reference: "Matthäus 28:19 - Geht hin und macht alle Völker zu Jüngern",
    context: "Die Mission Jesu ist universal, nicht auf ein Volk beschränkt"
  },
  {
    category: "spaltung",
    text: "Jesus ist nicht spaltend - Er betet für die Einheit der Gläubigen",
    reference: "Johannes 17:21 - Dass sie alle eins seien",
    context: "Lasst uns unsere Vielfalt feiern, statt Wortkriege zu führen"
  },
  {
    category: "wahrheit",
    text: "Jesus ist kein Lügner - Er deckt Lüge und Manipulation auf",
    reference: "Johannes 8:44 - Der Teufel ist der Vater der Lüge",
    context: "Jesus entlarvt Lügen und Manipulationen, die Seelen verletzen"
  },
  {
    category: "großzügigkeit",
    text: "Jesus ist nicht geizig - Seine Großzügigkeit übertrifft den Zehnten bei weitem",
    reference: "Lukas 21:3 - Diese arme Witwe hat mehr eingelegt als alle anderen",
    context: "Die Großzügigkeit Jesu ist stärker als die Verpflichtung des Zehnten"
  },
  {
    category: "gerechtigkeit",
    text: "Jesus ist kein Komplize des Schweigens - Er schützt durch gesunde Gerechtigkeit",
    reference: "Matthäus 18:6 - Wer einen dieser Kleinen verführt",
    context: "Schweigen, das Fehler verdeckt, ohne andere zu schützen, ist nicht Jesu Weisheit"
  }
];

export default jesusIsNot;
